<template>
<div>
    <router-view></router-view>
</div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style lang="css">
  @import './assets/css/paper-dashboard.css';
</style>
<style>
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import '~font-awesome/css/font-awesome.css';
  @import '~vue-snotify/styles/material.css';
  @import url('https://fonts.googleapis.com/css?family=Muli&display=swap');
</style>
 